import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Storage } from "@faire/web/common/Storage";
import { useCallback, useMemo } from "react";

const FINISHED_SIGNUP_ONBOARDING_KEY = "finished_signup_onboarding";

/**
 * This hook is used to check if the user has finished the signup onboarding.
 * Some users may try to go back via the browser back functionlity to enter the signup flow again.
 */
export const useFinishedSignupOnboarding = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();

  const hasFinishedSignupOnboarding = useMemo(() => {
    const finishedSignupOnboardingKey = Storage.local.getItem(
      FINISHED_SIGNUP_ONBOARDING_KEY
    );
    if (!isLoggedInRetailer && finishedSignupOnboardingKey !== undefined) {
      Storage.local.removeItem(FINISHED_SIGNUP_ONBOARDING_KEY);
    }

    return finishedSignupOnboardingKey === "true";
  }, [isLoggedInRetailer]);

  const setFinishedSignupOnboarding = useCallback(() => {
    const finishedSignupOnboardingKey = Storage.local.getItem(
      FINISHED_SIGNUP_ONBOARDING_KEY
    );

    if (isLoggedInRetailer && finishedSignupOnboardingKey !== "true") {
      Storage.local.setItem(FINISHED_SIGNUP_ONBOARDING_KEY, "true");
    }
  }, [isLoggedInRetailer]);

  return {
    hasFinishedSignupOnboarding,
    setFinishedSignupOnboarding,
  };
};
